(()=>{
  const FAMILY_ROUTES=new Map([
    ['agent','https://trustops.ecocitizenz.com/start/agent'],
    ['mcp','https://trustops.ecocitizenz.com/start/mcp'],
    ['plugin','https://trustops.ecocitizenz.com/start/plugin'],
    ['api','https://trustops.ecocitizenz.com/start/api'],
    ['iot','https://trustops.ecocitizenz.com/start/iot'],
    ['sdk','https://trustops.ecocitizenz.com/start/sdk'],
    ['service & workload','https://trustops.ecocitizenz.com/start/svc']
  ]);
  const normalise=s=>(s||'').replace(/\s+/g,' ').trim().toLowerCase();
  const applyFamilyRoutes=()=>{
    document.querySelectorAll('.ecz52-passport').forEach(card=>{
      const label=normalise(card.querySelector('h3')?.textContent);
      const route=FAMILY_ROUTES.get(label);
      if(!route) return;
      card.querySelectorAll('a').forEach(a=>{
        const text=normalise(a.textContent);
        if(text.includes('start free') && a.href.includes('trustops.ecocitizenz.com/start')){
          a.href=route;
          a.dataset.eczRoute=`passport-${label.replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')}`;
        }
      });
    });
    document.querySelectorAll('article').forEach(card=>{
      const title=normalise(card.querySelector('h3')?.textContent);
      if(title!=='agent passport') return;
      card.querySelectorAll('a[href*="trustops.ecocitizenz.com/start"]').forEach(a=>{
        a.href=FAMILY_ROUTES.get('agent');
        a.dataset.eczRoute='passport-agent';
      });
    });
  };
  const applyAnnualPrepaidTruth=()=>{
    document.querySelectorAll('p').forEach(p=>{
      const text=normalise(p.textContent);
      if(!text.startsWith('annual subscription options, where available,')) return;
      p.textContent='Annual prepaid options, where available, are shown through the purchase path. Annual is one payment for 12 months of entitlement; no annual auto-renewing Selling Plan is implied. No USDC checkout availability is implied here.';
      p.dataset.eczCommercialTruth='annual-prepaid';
    });
  };
  const applyLaunchPresentation=()=>{
    document.querySelectorAll('.ecz53-availability').forEach(el=>el.remove());
    const note=document.querySelector('.ecz53-productnote');
    if(note) note.remove();
    document.querySelectorAll('a[href="/products/ecz-parent-declared"],a[href="https://www.ecocitizenz.com/products/ecz-parent-declared"]').forEach(a=>{
      a.href='https://trustops.ecocitizenz.com/start';
      a.textContent='Start free →';
      a.dataset.eczRoute='parent-declared-free';
    });
  };
  const ready=()=>{
    const path=window.location.pathname.replace(/\/+$/,'')||'/';
    applyFamilyRoutes();
    applyAnnualPrepaidTruth();
    applyLaunchPresentation();
    if(path==='/pages/trust-verification-resolver'){
      const hero=document.querySelector('.eczgm2-pagehero h1');
      if(hero){
        hero.classList.add('ecz55-trust-actual');
        hero.innerHTML='<span class="ecz55-trust-line">TRUST SHOULD NOT REST ON A CLAIM.</span><span class="ecz55-trust-line">RE-CHECK THE PUBLISHED STATE.</span>';
      }
    }
    document.querySelectorAll('#msp a').forEach(a=>{
      a.href='https://msp.ecocitizenz.com/';
      if((a.textContent||'').toLowerCase().includes('msp')) a.textContent='Explore MSP / MSSP →';
      a.dataset.eczRoute='msp';
    });
    document.querySelectorAll('#platforms a').forEach(a=>{
      a.href='/pages/cloud-platform-binding';
      if((a.textContent||'').toLowerCase().includes('platform')) a.textContent='Explore platform integration →';
      a.dataset.eczRoute='platform-binding';
    });
    document.querySelectorAll('.eczgm2-stakeholders a').forEach(a=>{
      const b=a.querySelector('b');
      const label=((b&&b.textContent)||a.textContent||'').trim().toLowerCase();
      if(label.includes('msp')||label.includes('mssp')){
        a.href='https://msp.ecocitizenz.com/';
        a.dataset.eczRoute='msp';
      }else if(label.includes('hyperscaler')||label.includes('platform partner')){
        a.href='/pages/cloud-platform-binding';
        a.dataset.eczRoute='platform-binding';
      }
    });
    document.querySelectorAll('a[href="/pages/for-businesses#msp"],a[href="https://www.ecocitizenz.com/pages/for-businesses#msp"]').forEach(a=>{
      a.href='https://msp.ecocitizenz.com/';
      a.dataset.eczRoute='msp';
    });
    document.querySelectorAll('a[href="/pages/for-businesses#platforms"],a[href="https://www.ecocitizenz.com/pages/for-businesses#platforms"]').forEach(a=>{
      a.href='/pages/cloud-platform-binding';
      a.dataset.eczRoute='platform-binding';
    });
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',ready,{once:true}):ready();
})();
